import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import jobTitleToSlug from '../../utils/jobTitleToSlug';
import { Content } from '../../theme/page';
import Typography from '../../atoms/typography';
import Heading from '../heading';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.color.bluePrimary};
  padding: 4rem 0 0.3rem;

  scroll-margin-top: 215px;

  @media (max-width: ${({ theme }) => theme.breakpoint.medium}) {
    scroll-margin-top: 150px;
  }
`;

const Department = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.bluePrimary};
  margin-bottom: 3.2rem;
  padding-bottom: 1.6rem;

  &:last-child{
    border: 0;
    margin-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.medium}) {
    padding-bottom: 0;
  }
`;

const DepartmentTitle = styled(Typography)`
  margin-bottom: 3.2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.medium}) {
    font-size: ${({ theme }) => theme.modularScale.twentyFour};
    margin-bottom: 1.6rem;
  }
`;

const Job = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.6rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.medium}) {
    flex-direction: row;
    margin-bottom: 3.2rem;
  }
`;

const JobTitle = styled.a`
  font-size: ${({ theme }) => theme.modularScale.eighteen};
  margin-bottom: 0.8rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.medium}) {
    font-size: ${({ theme }) => theme.modularScale.twenty};
    margin-bottom: 0;
  }
`;

const JobLocation = styled(Typography)`
  color: ${({ theme }) => theme.color.bluePrimary};

  @media (max-width: ${({ theme }) => theme.breakpoint.medium}) {
    font-size: ${({ theme }) => theme.modularScale.sixteen};
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.medium}) {
    margin-left: auto;
    width: 190px;
  }
`;

const NoOpenRoles = styled.div`
  margin-bottom: 3.1rem;
  text-align: center;
`;

const NoOpenRolesTitle = styled(Typography)`
  margin-bottom: 1.6rem;
`;

const haveOpenRoles = (list) => list && list.some((item) => item.jobs?.length > 0);

const JobList = ({ jobs }) =>
  jobs.map((job) => (
    <Job key={job.id}>
      <JobTitle href={`careers/${jobTitleToSlug(job.title)}`} target="_blank">{job.title}</JobTitle>
      <JobLocation element="p" like="dec-6">{job.location.name}</JobLocation>
    </Job>
  ));

const JobListing = forwardRef((props, ref) => (
  <Content>
    <Wrapper ref={ref} id="open-roles">
      <Heading data={{ title: 'Open roles' }} careerUpdate />

      {
        haveOpenRoles(props.list)
          ? props.list.map(
            (item, idx) =>
              item?.jobs?.length > 0 && (
                <Department key={item?.name ?? idx}>
                  <DepartmentTitle element="h3" like="heading-7">
                    {item.name}
                  </DepartmentTitle>
                  <JobList jobs={item.jobs} />
                </Department>
              )
          )
          : (
            <NoOpenRoles>
              <NoOpenRolesTitle element="h3" like="heading-7">No open roles available</NoOpenRolesTitle>
              <Typography element="p" like="dec-6">
                If you would like to be a part of the Maisonette team, please contact us
                {' '}
                <a href="/contact">here</a>
                !
              </Typography>
            </NoOpenRoles>
          )
      }
    </Wrapper>
  </Content>

));

JobListing.propTypes = {
  list: PropTypes.array
};

export default JobListing;
